import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import "./News.scss";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Select from "react-select";
import { imageUpload } from "../../services/BannersServices";
import Dropzone from "react-dropzone";
import { Constants } from "../../Constants";
import { EditorState } from "draft-js";
import { fetchNew, postNew, putNew } from "../../services/NewsServices";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { stateFromHTML } from "draft-js-import-html";
import { stateToHTML } from "draft-js-export-html";
import { useHistory } from "react-router";
import ViewInWeb from "../../components/Common/ViewInWeb";

function News(props: any) {
  const [image, setImage] = useState("");
  const [title, setTitle] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [description, setDescription] = useState(EditorState.createEmpty());
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState({ value: "interna", label: "Interna" });
  const { id } = props.match.params;
  const history = useHistory();

  useEffect(() => {
    if (Number(id) !== 0) {
      fetch();
    }
  }, []);

  const uploadCallback = async (file: any) => {
    const result = {
      data: {
        link: "",
      },
    };
    try {
      var form = new FormData();
      form.append("file", file);
      let response = await imageUpload({
        form,
        token: "",
        type: "textEdition",
      });
      result.data.link = `${Constants.BASE_URL}${response.data.data.image}`;
    } catch (error: any) {
      console.log(error.response);
    }
    return result;
  };

  const handleAcceptedFiles = async (files: any) => {
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "news",
        });
        setImage(response.data.data.image);
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchNew({
        token: "",
        id,
      });
      let { description, enlace, image, short_description, title, type } =
        response.data.data;
      setLoading(false);
      setDescription(EditorState.createWithContent(stateFromHTML(description)));
      setImage(image);
      setShortDescription(short_description);
      setTitle(title);
      setLink(enlace);
      if (type === "interna") {
        setType({ value: "interna", label: "Interna" });
      } else {
        setType({ value: "externa", label: "Externa" });
      }
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let data = {
        description: stateToHTML(description.getCurrentContent()),
        image,
        title,
        short_description: shortDescription,
        enlace: link,
        type: type.value,
      };
      if (Number(id) !== 0) {
        let response = await putNew({
          token: "",
          id,
          ...data,
        });
      } else {
        let response = await postNew({
          token: "",
          ...data,
        });
        history.push("/news");
      }
      setLoading(false);
      toast(`Noticia guardada con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Novedades" breadcrumbItem="Novedades" />
          <Row>
            <Col>
              <FormGroup>
                <Label>Tipo de novedad</Label>
                <Select
                  value={type}
                  onChange={(e: any) => setType(e)}
                  options={[
                    { value: "interna", label: "Interna" },
                    { value: "externa", label: "Externa" },
                  ]}
                />
              </FormGroup>
              <FormGroup className="mt-2">
                <Label>Título</Label>
                <Input
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </FormGroup>
              <FormGroup className="mt-2">
                <Label>Descripción corta</Label>
                <Input
                  value={shortDescription}
                  onChange={(e) => setShortDescription(e.target.value)}
                />
              </FormGroup>
              {type.value === "interna" ? (
                <>
                  <FormGroup className="mt-2" style={{ marginBottom: "2rem" }}>
                    <Label>Contenido</Label>
                    <Editor
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName"
                      toolbar={{
                        options: [
                          "inline",
                          "blockType",
                          "link",
                          "emoji",
                          "image",
                        ],
                        inline: { inDropdown: true },
                        link: { inDropdown: true },
                        image: { uploadCallback },
                      }}
                      editorState={description}
                      onEditorStateChange={(d: any) => setDescription(d)}
                    />
                  </FormGroup>
                </>
              ) : (
                <Form method="post">
                  <FormGroup className="mt-2 mb-2">
                    <Label>Enlace url</Label>
                    <Input
                      value={link}
                      onChange={(e) => setLink(e.target.value)}
                    />
                  </FormGroup>
                </Form>
              )}
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-2"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-3">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                      </div>
                      <h4>Drop files here or click to upload.</h4>
                    </div>
                  </div>
                )}
              </Dropzone>
              <div className="dropzone-previews mt-3" id="file-previews">
                {image && (
                  <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                    <div className="p-2">
                      <Row className="align-items-center">
                        <Col className="col-auto">
                          <img
                            data-dz-thumbnail=""
                            height="80"
                            className="avatar-sm rounded bg-light"
                            alt=""
                            src={`${Constants.BASE_URL}${image}`}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Card>
                )}
              </div>
              <div className="row" style={{ marginTop: "1rem" }}>
                <div className="col-12 text-right">
                  {Number(id) !== 0 && (
                    <ViewInWeb
                      link={`https://mariomendez.uy/novedades/${id}`}
                    />
                  )}
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => save()}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default News;
